import React, { useState, useReducer } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';

import ActionButton, { SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import Checkbox from '../builder/Checkbox';
import Input from '../builder/Input';
import Message from '../builder/Message';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import SearchField from '../builder/SearchField';
import Select from '../builder/Select';
import Spinner from '../builder/Spinner';
import ToggleButton from '../builder/ToggleButton';
import Tooltip from '../builder/Tooltip';

import PhotoEmbed from '../front/PhotoEmbed';
import SingleGallery from '../front/SingleGallery';

import { useFilterDataQuery, usePaginator, operators } from '../FilterContent';
import { useCSS } from '../../lib/hooks.js';
import Module from '../ui_items/Module.js';

const VotingCandidateSelector = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage = (props.stage != undefined) ? props.stage : false;
	const promotion = (props.promotion != undefined) ? props.promotion : false;
	
	if(!stage) return null;

	useCSS('comp/owner_multigallery.css');
	useCSS('comp/multigallery.css');
	
	const items_per_page = 12;

	const getUsers = (start = false, limit = 100) => {
		if(limit == 100) setLoading(true);

		let url = `/users/fetch_gallery/${stage.id}`;

		if(stage.type == 8) {
			url = `/stages/getvotingcandidates/${stage.promotion_id}/${stage.id}`;
		}

		return $.getJSON(getRemotedbUrl(url), { start, limit }, (res) => {
			setLoading(false);
		});
	}

	const [galleryState, dispatchGallery] = useReducer((state, action) => {
		switch (action.type) {
			case 'OPEN_ENTRY':
				return {...state, current_participation:action.participation, current_media:action.media_index};

			case 'CLOSE_ENTRY':
				return {...state, current_participation:false, current_media:0};

			case 'TOGGLE_CANDIDATE':
				let new_candidates = {...state.candidates};
				if (new_candidates[action.id] == undefined) new_candidates[action.id] = 1;
				else delete new_candidates[action.id];
				return {...state,candidates:new_candidates}

			case 'ADD_FILTERED':
				let add_filtered = {...state.candidates};
				for (var i in action.candidates) {
					add_filtered[action.candidates[i].Participation.id] = 1;
				}
				return {...state,candidates:add_filtered}
			case 'REMOVE_FILTERED':
				let remove_filtered = {...state.candidates};
				for (var i in action.candidates) {
					if (remove_filtered[action.candidates[i].Participation.id] == undefined) continue;
					delete remove_filtered[action.candidates[i].Participation.id];
				}
				return {...state,candidates:remove_filtered}

			case 'CHANGE_VOTES':
				return {...state,min_votes:action.min_votes}

			case 'CHANGE_LIMIT':
				return {...state,limit:action.limit}

			case 'CHANGE_SORT':
				return {...state,sort:action.sort}

			default:
				return state;
		}
	}, {
		current_media:0,
		current_participation:false,
		candidates:{},
		min_votes:0,
		limit:0,
		sort:'-',
	});

	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState("");

	const [state, dispatch, fetchAll] = useFilterDataQuery('media', getUsers, {
		indexer:(indexed, element) => {
			return;
			//indexed[element.Participation.id] = { name:element.Participa.name }
		},
		limit:items_per_page,
		pagination:500,
		fetch_all_disabled:false,
		items_per_page:items_per_page
	});

	const [data, pagination, goToPage] = usePaginator(state.filtered, items_per_page,{
		limit:galleryState.limit,
		reset_page_on_items_length:true,
	});

	const openEntryAsLayer = (participation, media_index) => {
		dispatchGallery({
			type:'OPEN_ENTRY',
			participation,
			media_index,
		});
	};

	const closeEntryAsLayer = () => {
		dispatchGallery({ type:'CLOSE_ENTRY' })
	};

	const searchEntries = (k, value) => {
		const filter = {
			key:'search',
			name:"Name",
			tier1:['Participation.search_media_values'],
			tier2:{...operators.textOperators},
			tier3:'input',
			type:'string',
		};

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'search',
				value,
				operator:'like_all',
				filter,
			},
			unique:true,
		});

		setSearch(value);
	};

	if(loading) {
		return (
			<div>
				<article class="entries_list" style={{minHeight:'300px'}}>
					<Spinner autotranslate={false}>{i18n("Loading the gallery")}...</Spinner>
				</article>
			</div>
		)
	}

	const toggleParticipant = (participant) => {
		dispatch({
			type:'APPLY_ACTION',
			match:(u) => (u.Participation.id == participant.Participation.id) ? true : false,
			action:(u) => {
				return {
					...u,
					Participation:{
						...u.Participation,
						selected:(u.Participation.selected != undefined) ? !u.Participation.selected : true,
					},
				}
			}
		});
	};

	const confirmPartialCandidates = (e, cb) => {
		const ids = getSelectedEntries().map((u) => (u.Participation.id));
		const participants_ids = JSON.stringify(ids);

		$.post(`/stages/assign_vote_candidates/${promotion.id}/${props.original_stage.id}`, { source:stage.id, participants_ids }, () => {
			if(props.original_stage.voting_selection == undefined) {
				props.change('voting_selection', true);
				if(props.save != undefined) props.save();
			}
			props.importEnded();
			if(cb != undefined) cb();
		});
	};

	const addAll = () => {
		const limited = galleryState.limit == 0 ? state.filtered : state.filtered.slice(0,galleryState.limit);
		const selected = limited.map(u=>(u.Participation.id));
		dispatch({
			type:'APPLY_ACTION',
			match:(u) => selected.includes(u.Participation.id),
			action:(u) => {
				return {
					...u,
					Participation:{
						...u.Participation,
						selected:true,
					},
				}
			}
		});
	};

	const removeFiltered = () => {
		const limited = (galleryState.limit == 0) ? state.filtered : state.filtered.slice(0, galleryState.limit);
		const selected = limited.map((u) => (u.Participation.id));
		dispatch({
			type:'APPLY_ACTION',
			match:(u) => selected.includes(u.Participation.id),
			action:(u) => {
				return {
					...u, Participation:{
						...u.Participation,
						selected:false,
					},
				}
			}
		});
	};

	const setOrder = (v) => {
		let sort = false;
		switch(v) {
			case 'created_desc':
				sort = { field:'Participation.created', direction:'DESC' };
				break;

			case 'created_asc':
				sort = { field:'Participation.created', direction:'ASC' };
				break;

			case 'votes_desc':
				sort = { field:'StageVote.points', direction:'DESC', type:'numeric' };
				break;
		}

		dispatch({
			type:'SETSORT',
			sort,
		});

		dispatchGallery({ type:'CHANGE_SORT', sort:v });
	};

	const toggleSelected = () => {
		const filter = {
			key:'selected',
			name:i18n("Selected entries"),
			tier1:['Participation.selected'],
		};

		if(state.filters.find((f) => f.key == 'selected')) {
			dispatch({
				type:'REMOVEFILTER',
				filter:{
					key:'selected',
					operator:'=',
				},
			});
			return;
		}

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'selected',
				value:true,
				operator:'=',
				filter,
			},
			unique:true,
		});
	};

	const toggleMarked = () => {
		const filter = {
			key:'marked',
			name:i18n("Marked entries"),
			type:'numeric',
			tier1:['Participation.extra.marked'],
		};

		if(state.filters.find((f) => f.key == 'marked')) {
			dispatch({
				type:'REMOVEFILTER',
				filter:{
					key:'marked',
					operator:'=',
				},
			});
			return;
		}

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'marked',
				value:1,
				operator:'=',
				filter,
			},
			unique:true,
		});
	};

	const filterByVotes = (votes) => {
		const filter = {
			key:'votes',
			name:i18n("votes", 'ucfirst'),
			type:'numeric',
			tier1:['StageVote.points'],
		};

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'votes',
				value:votes,
				operator:'>=',
				filter,
			},
			unique:true,
		});

		dispatchGallery({ type:'CHANGE_VOTES', min_votes:votes });
	};

	const setLimit = (limit) => {
		dispatchGallery({ type:'CHANGE_LIMIT', limit });
	};

	const getResponsiveImageUrl = (file, size) => {
		const type_media = (file.type != undefined) ? file.type : 'image';
		if(size == undefined) size = 'normal';

		let thumbnail;
		let size_thumb;
		switch(type_media) {
			case 'video':
			case 'vimeo':
				switch(size) {
					case 'big':
						size_thumb = '1920x1080';
						break;

					case 'thumb':
						size_thumb = '360x640';
						break;

					case 'normal':
					default:
						size_thumb = '1280x720';
						break;
				}

				thumbnail = `${file.full_path}${file.filename}_${size_thumb}?r=pad`;
				break;

			case 'youtube':
				switch(size) {
					case 'big':
						size_thumb = 'maxresdefault';
						break;

					case 'thumb':
						size_thumb = 'sddefault';
						break;

					case 'normal':
					default:
						size_thumb = 'hqdefault';
						break;
				}

				thumbnail = `${file.full_path}${file.filename}/${size_thumb}.jpg`;
				break;

			case 'image':
			default:
				thumbnail = `${file.full_path}${size}/${file.filename}`;
				break;
		}

		return thumbnail;
	};

	const getSelectedEntries = () => {
		if(!state.data) return [];
		if(!Array.isArray(state.data)) return [];
		return state.data.filter((s) => (s.Participation.selected != undefined && s.Participation.selected));
	};

	const changeFilter = (k, v) => {
		switch(k) {
			case 'only_marked':
				toggleMarked();
				break;

			case 'only_selected':
				toggleSelected();
				break;

			case 'order_by':
				setOrder(v);
				break;

			case 'min_votes':
				filterByVotes(v);
				break;

			case 'limit_to':
				setLimit(v);
				break;
		}
	};

	const num_candidates = getSelectedEntries().length;
	const totals = (data.length != state.total) ? `${data.length}/${state.total}` : state.total;

	const show_only_selected = state.filters.find((f) => f.key == 'selected') != null;
	const show_only_marked = state.filters.find((f) => f.key == 'marked') != null;
	const sort_values = [
		{ k:'-', v:i18n("Candidates order") },
		{ k:'created_desc', v:i18n("Last uploads") },
		{ k:'created_asc', v:i18n("First uploads") },
		{ k:'votes_desc', v:i18n("Most voted") },
	]

	return (
		<section class="gui_users_registered full_height_flexed">
			<Module>
				<div class="candidates_picker">
					<div class="candidates_list">
						<div>
							<ul class="multigallery_tool simple_registered_entries_list in_layer visible_overflowed_container wt_bg">
								{(data.length > 0) ? (
									data.map((_user, u) => {
										if(_user.Participation == undefined) return null;
										const participation = _user.Participation;

										const album_title = (participation.quiz_entry.title != undefined && participation.quiz_entry.title != "") ? participation.quiz_entry.title : false;
										const album_description = (participation.quiz_entry.description != undefined && participation.quiz_entry.description != "") ? participation.quiz_entry.description : false;
										const media = participation?.quiz_entry?.media ?? [];

										const gallery_count = media.length;
										const is_selected = (galleryState.current_participation !== false && participation.id == galleryState.current_participation.id) ? true : false;
										const partial_selected = participation?.selected ?? false;

										const has_internal_comment = (participation.extra && participation.extra.comment != undefined) ? true : false;

										let li_classes = ['single_item', 'is_toggable'];
										if(partial_selected) li_classes.push('is_selected');

										return (
											<li key={u} class={li_classes.join(" ")}>
												<div class="tabled_item static_entry_info is_linked_element" onClick={(e, i) => toggleParticipant(_user)}>
													<span class="entry_counter">
														<ButtonCollection _class={{other:'gui_not_margined_v'}}>
															<SquaredButton
																icon={(participation.marked) ? 'ep-star' : 'ep-star-empty'}
																_class={{ other:'gui_remove_pointer_events small_squared_button' }}
															/>
														</ButtonCollection>
													</span>

													<span class="user_name">
														<strong class="blueColor">{participation.name}</strong>

														{(_user.StageVote != undefined) && (
															<span>{i18n("votes", 'ucfirst')}: {_user.StageVote.points}</span>
														)}

														{(album_title != false) &&(
															<span class="album_title" dangerouslySetInnerHTML={{ __html:'<span>' + i18n("Album") + ':</span> ' + album_title.replace(/\n/g, '<br />') }} />
														)}
													</span>

													<span class="displaced" style={{flexBasis:'150px'}}>{EPDateFormat(participation.created, 'L, LT')} h</span>

													<ButtonCollection _class={{other:'user_actions gui_not_margined_v'}} style={{flexBasis:'30px'}}>
														<ToggleButton
															squared={true}
															active={partial_selected}
															icon='knk-slide-on greenIcon'
															icon_off='knk-slide-off redIcon'
															tooltip={<Tooltip with_icon={false}>This will be imported</Tooltip>}
														/>
													</ButtonCollection>
												</div>

												<div class="album">
													{(gallery_count > 0 || album_description !== false) && (
														<ul class="medias">
															{(album_description !== false) && (
																<li class="description" onClick={() => openEntryAsLayer(participation, 0)}>
																	<p dangerouslySetInnerHTML={{ __html:album_description.replace(/\n/g, '<br />')}} />
																</li>
															)}

															{gallery_count > 0 && media.map((element, m) => {
																const type_media = (element.type != undefined) ? element.type : 'image';

																let props_media_component = {};
																let li_classes = [];
																switch(type_media) {
																	case 'video':
																	case 'vimeo':
																		//element.full_path = `https://i.vimeocdn.com/video/${element.pictures_id}`;
																		li_classes.push('original_color_item with_media_icon ep-video');
																		break;

																	case 'youtube':
																		if(!is_selected) element.full_path = element.thumbnail;
																		li_classes.push('original_color_item with_media_icon ep-video');
																		break;

																	case 'audio':
																		li_classes.push('original_color_item with_media_icon ep-audio');
																		break;
																	case 'pdf':
																		li_classes.push('original_color_item with_media_icon ep-pdf');
																		element.filename = element.cover_name;
																	case 'image':
																	default:
																		props_media_component.file = element;
																		break;
																}

																return (
																	<li key={m} class={li_classes.join(" ")} onClick={() => openEntryAsLayer(participation, m)}>
																		<PhotoEmbed file={element} type="normal" adapt="height" type_media={type_media} />
																	</li>
																)
															})}
														</ul>
													)}

													{(has_internal_comment) && (
														<div class="extra_information">
															{(has_internal_comment) && (
																<div class="knk-comment gui_small_icon">{participation.extra.comment}</div>
															)}
														</div>
													)}
												</div>

												{(is_selected && galleryState.current_participation !== false && galleryState.current_participation.id == participation.id) && (
													<ul class="gui_multimedia_gallery">
														<SingleGallery
															intl={props.intl}
															in_registered={true}
															closeEntryAsLayer={closeEntryAsLayer}
															promotion={{}}
															stage={stage}
															selected_entry={participation.id}
															user={{Participation:galleryState.current_participation}}
															has_voting_sidebar={false}
														/>
													</ul>
												)}
											</li>
										)})
								) : (
									<li>{i18n("There are no results.")}</li>
								)}
							</ul>

							{(pagination.total_pages > 0) && (
								<div class="gui_paginator" style={{marginTop:'2em'}}>
									<ul>
										<li class={(pagination.page == 1) ? 'disabled' : null}>
											<SquaredButton
												icon='knk-arrow-l-big'
												color={(pagination.page == 1) ? 'black' : 'blue'}
												_class={{other:'gui_small_icon go_prev_page not_bordered_button'}}
												onClick={() => goToPage((pagination.page > 1) ? (pagination.page -1) : 1)}
												tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("previous", 'ucfirst')}</Tooltip>}
												aria-label="Go to previous page"
											/>
										</li>
			
										{pagination.pages_arr.map((page, p) => {
											const selected = (page == pagination.page) ? true : false;
											let page_label = page;
											if(pagination.total_pages > 10) {
												if(parseInt(page_label) < 10) page_label = `0${page_label}`;
												if(pagination.total_pages > 100) {
													if(parseInt(page_label) < 100) page_label = `0${page_label}`;
													if(pagination.total_pages > 1000) {
														if(parseInt(page_label) < 1000) page_label = `0${page_label}`;
													}
												}
											}
			
											return (
												<li key={p} class={'page_number' + ((selected) ? ' selected' : '')}>
													<ActionLink
														onClick={() => goToPage(page)}
														autotranslate={false}
													>{page_label}</ActionLink>
												</li>
											)
										})}
			
										<li class={(pagination.page == pagination.total_pages) ? 'disabled' : null}>
											<SquaredButton
												color={(pagination.page < pagination.total_pages) ? 'black' : 'blue'}
												icon='knk-arrow-r-big'
												_class={{ other:'gui_small_icon go_next_page not_bordered_button' }}
												onClick={() => goToPage((pagination.page < pagination.total_pages) ? (pagination.page + 1) : pagination.total_pages)}
												tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("next", 'ucfirst')}</Tooltip>}
												aria-label="Go to next page"
											/>
										</li>
									</ul>
								</div>
							)}
						</div>
					</div>

					<aside class="selected_entries">
						<SearchField change={searchEntries} _class={{first:true}} name="search" value={search} _placeholder="Search by name" />

						<Model change={(k, v) => changeFilter(k, v)}>
							<Select name="order_by" value={galleryState.sort} values={sort_values}>Order by</Select>

							{(stage.type == 8) && (//only from stage voting gallery
								<Input name="min_votes" value={galleryState.min_votes} _class={{size:30}}>Minimum of votes</Input>
							)}

							<Input name="limit_to" value={galleryState.limit} _class={{size:30}}>Limit to</Input>

							<Checkbox name="only_marked" value={show_only_marked}>Show only favorites</Checkbox>

							<Checkbox name="only_selected" value={show_only_selected}>Show only selected</Checkbox>
						</Model>

						<Message
							type='blank'
							icon={false}
							_class={{ other:'not_in_top gui_not_in_bottom_small' }}
							title={`${i18n("Total candidates")}: ${totals}`}
						/>

						{(data.length > 0) && (
							<ul>
								<li class="gui_not_in_bottom_tiny"><ActionLink _class={{icon:'knk-plus', other:'gui_small_icon'}} onClick={addAll} autotranslate={false}><FormattedMessage id="Add {total} participants" values={{total:data.length}} /></ActionLink></li>

								<li><ActionLink _class={{icon:'knk-minus', other:'gui_small_icon'}} onClick={removeFiltered} autotranslate={false}><FormattedMessage id="Remove {total} participants" values={{total:data.length}} /></ActionLink></li>
							</ul>
						)}

						<Message
							type='blue'
							title={`${i18n("Selected entries")}: ${getSelectedEntries().length}`}
							icon={false}
							autotranslate={false}
							_class={{ other:'not_in_top' }}
						/>

						<ButtonCollection _class={{other:'not_in_top'}}>
							<SecondaryButton
								onClick={() => props.backButton()}
							>Close layer</SecondaryButton>

							<SaveButton
								disabled={num_candidates == 0}
								onClick={confirmPartialCandidates}
							>Confirm</SaveButton>
						</ButtonCollection>
					</aside>
				</div>
			</Module>
		</section>
	);
}

export default injectIntl(VotingCandidateSelector);